var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('h1',{staticClass:"ubuntu"},[_vm._v("Labs")]),_c('p',[_vm._v("This is where I will play around with different technologies.")])])}]

export { render, staticRenderFns }